/**
 * Get URL parameter of current url.
 */ function urlParam(name, url = window.location.href) {
    return new URL(url).searchParams.get(name);
}
export { urlParam };
